import { Modal, ModalProps, Row } from 'antd';
import React from 'react';
import close from './close-circle-fill.png';
import Calculator from './Calculator/index.js';
import styled from 'styled-components';
const styles: ModalProps['styles'] = {
  header: { display: 'none' },
  content: { padding: 0, background: 'rgba(255,255,255,0.9)' },
};
type Props = {
  visible?: boolean;
  onClose?: () => void;
};
const CalculatorModal = ({ onClose = () => undefined, visible }: Props) => {
  return (
    <Modal
      title='Calculator'
      visible={visible}
      footer={<></>}
      onClose={onClose}
      styles={styles}
      className='modal-overflow-unset'
      width={'60vw'}
      closable={false}
    >
      <ModalStyled>
        <button className='icon-close' onClick={onClose}><IconClose /></button>
        <Calculator />
      </ModalStyled>
    </Modal>
  );
};

export default CalculatorModal;

const ModalStyled = styled.div`
  position: relative;
  padding: 1rem;
  text-align:right;
  .icon-close {
    position: absolute;
    width: 42px;
    height: 42px;
    top: 0;
    right: 0;
    transform: translate(18px, -20px);
  }
`;

const IconClose = () => (
  <Row>
    <img src={close} style={{ height: '100%', width: '100%' }} />
  </Row>
);
